import { ANCHOR_TAG_NAME, IMG_TAG_NAME } from './constants';
import processAnchorElements, {
    AnchorElementsSource,
    getUrl,
} from './processAnchorElementsFromHtmlContent';
import LinkPlugin from '../plugin/LinkPlugin';
import { isFeatureEnabled } from 'owa-feature-flags';
import { AttachmentWellViewState } from 'owa-attachment-well-data';
import { trace } from 'owa-trace';
import { BeforePasteEvent, PasteOption } from 'roosterjs-editor-types';

export default async function handleBeforePasteEvent(
    event: BeforePasteEvent,
    linkPlugin: LinkPlugin,
    viewState: AttachmentWellViewState,
    linkIdsWithSpinner: string[]
) {
    if (!isFeatureEnabled('doc-beautify-link') || event.pasteOption !== PasteOption.PasteHtml) {
        return;
    }

    trace.info('LinkPlugin.handleBeforePasteEvent');
    const links = event.fragment.querySelectorAll(ANCHOR_TAG_NAME);
    const images: NodeListOf<HTMLImageElement> = event.fragment.querySelectorAll(IMG_TAG_NAME);
    const isPureLinks: boolean = isPastedTextPureLinks(event.fragment.textContent, links);
    processAnchorElements(
        links,
        null,
        AnchorElementsSource.PasteHtml,
        linkPlugin,
        viewState,
        linkIdsWithSpinner,
        isPureLinks && images.length === 0
    );
}

function isPastedTextPureLinks(text: string, allLinks: NodeListOf<HTMLAnchorElement>): boolean {
    const textAfterWhitespaceRemoved: string = text.replace(/\s/g, '');
    let allHrefTogether: string = '';
    for (let i = 0; i < allLinks.length; i++) {
        const link = allLinks[i] as HTMLAnchorElement;
        allHrefTogether += getUrl(link);
    }

    return textAfterWhitespaceRemoved.toLowerCase() === allHrefTogether.toLowerCase();
}
